import { DesignElementBase, DesignElementBrandedPart, DesignElementGroupablePart, DesignElementSlugPart, } from "./base";
import { ElementGroupDataV2 } from "./data";
import { DesignElementType } from "./raw-element";
import { z } from "zod";
export const ElementGroup = DesignElementBase.extend(DesignElementGroupablePart.shape)
    .extend(DesignElementSlugPart.shape)
    .extend(DesignElementBrandedPart.partial().shape)
    .extend({
    shortPersistentId: z.string().optional(),
    childType: DesignElementType,
    data: ElementGroupDataV2.optional(),
});
export const BrandedElementGroup = ElementGroup.extend(DesignElementBrandedPart.shape);
